import Flickity from 'flickity';
import FlickityFade from 'flickity-fade';

let elems = document.querySelectorAll('.review-carousel');
let options = {
    cellAlign: 'center',
    wrapAround: true,
    prevNextButtons: true,
    fade: true,
    pageDots: true,
    selectedAttraction: 0.01,
    friction: 0.15,
    autoPlay: 5000
}

for (var i = elems.length - 1; i >= 0; i--) {
    var flkty = new Flickity(  elems[i], options);
};
